import { ModalStackItem, ModalOptions } from './types';

let modalId = 1;

export function makeModal(type: string, options: ModalOptions): ModalStackItem {
  return {
    id: modalId++,
    type,
    options,
  };
}
